import { Task } from '@/models/Task';
import { apiClient } from '@/services/api';
import { logger } from '@/utils/logger/loggerInstance';

export const getTasks = async (dealId: string, listingId?: string): Promise<Task[]> => {
  const url = `/deals/${dealId}/tasks${
    listingId ? `?listingId=${encodeURIComponent(listingId)}` : ''
  }`;

  logger.debug(`GET ${url}`);
  const response = await apiClient.get<Task[]>(url);

  return response.data;
};

export const completeTask = async (taskId: string): Promise<Task> => {
  const url = `/tasks/${taskId}/complete`;

  logger.debug(`POST ${url}`);
  const response = await apiClient.post<Task>(url);

  return response.data;
};

export const uncompleteTask = async (taskId: string): Promise<Task> => {
  const url = `/tasks/${taskId}/uncomplete`;

  logger.debug(`POST ${url}`);
  const response = await apiClient.post<Task>(url);

  return response.data;
};
